import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import QuantityInputField from '../QuantityInputField';
import StockStatusTag from '../StockStatusTag';
import QuickOrderAutoComplete from './QuickOrderAutoComplete';

const QuickOrderMobileTable = (props) => {
  const {
    rows,
    showNameAutoComplete,
    onTabClick,
    onAutoCompleteItemSelected,
    clearRow,
    queryResult,
    isLoading,
    onArticleNumblerBlur,
    onQuantityInputChange,
    onNameInputChange,
    onNoteInputChange,
    onArticleNumblerChange,
  } = props;
  const [currentRow, setCurrentRow] = useState();

  return (
    <>
      <div className="quick-order-mobile">
        {rows?.map((row, index) => {
          return (
            <div
              className={`quick-order-mobile__row ${
                row.articleNumber &&
                row.name &&
                'quick-order-mobile__row--filled'
              }`}
              key={'row' + index}
            >
              <div
                className={`quick-order-mobile__input-wrapper ${
                  row.error ? 'quick-order-mobile__input-wrapper--error' : ''
                }`}
              >
                <label className="text-medium lh-1 bold color-grey-900">
                  {translate('quickorder.articlenumber')}
                </label>
                <input
                  placeholder={translate(
                    'quickorder.placeholder.articlenumber'
                  )}
                  type="text"
                  className="table-input"
                  value={row.articleNumber ?? ''}
                  onFocus={(e) => setCurrentRow(index)}
                  onKeyDown={(e) =>
                    (e.key == 'Tab' || e.key == 'Enter') && onTabClick(index)
                  }
                  onChange={(e) =>
                    onArticleNumblerChange(
                      index,
                      'articleNumber',
                      e.target.value
                    )
                  }
                  onBlur={(e) => onArticleNumblerBlur(index, e.target.value)}
                />
                <span className="quick-order-mobile__error-message">
                  {translate('quickorder.article-could-not-be-added')}
                </span>
              </div>
              <div className="quick-order-mobile__input-wrapper auto-fill-container">
                <label className="text-medium lh-1 bold color-grey-900">
                  {translate('quickorder.name')}
                </label>
                <input
                  placeholder={translate('quickorder.placeholder.name')}
                  className="table-input"
                  type="text"
                  value={row.name && row.name != null ? row.name : ''}
                  onFocus={(e) => setCurrentRow(index)}
                  onKeyDown={(e) =>
                    (e.key == 'Tab' || e.key == 'Enter') && onTabClick(index)
                  }
                  onChange={(e) =>
                    onNameInputChange(index, 'name', e.target.value)
                  }
                />
                {currentRow == index && showNameAutoComplete && (
                  <QuickOrderAutoComplete
                    isLoading={isLoading}
                    queryResult={queryResult}
                    onItemSelected={(item) =>
                      onAutoCompleteItemSelected(item, index)
                    }
                  />
                )}
              </div>
              {row.articleNumber && row.name && (
                <div className="quick-order-mobile__input-wrapper">
                  <label className="text-medium lh-1 bold color-grey-900">
                    {translate('quickorder.note')}
                  </label>
                  <input
                    placeholder={translate('quickorder.placeholder.note')}
                    type="text"
                    className="table-input"
                    value={row.note && row.note != null ? row.note : ''}
                    onKeyDown={(e) =>
                      (e.key == 'Tab' || e.key == 'Enter') && onTabClick(index)
                    }
                    onChange={(e) =>
                      onNoteInputChange(index, 'note', e.target.value)
                    }
                  />
                </div>
              )}
              {row.articleNumber && row.name && (
                <div>
                  <label className="text-medium lh-1 bold color-grey-900">
                    {translate('quickorder.inventory')}
                  </label>
                  <StockStatusTag
                    isInStock={row.inStock}
                    description={row.stockStatusDescription}
                    stockStatusType={row.stockStatusType}
                  />
                </div>
              )}
              {row.articleNumber && row.name && (
                <div className="quick-order-mobile__row-footer">
                  <div>
                    <label className="text-medium lh-1 bold color-grey-900">
                      {translate('quickorder.price')}
                    </label>
                    {row.formattedPrice && (
                      <div className="text-large lh-2 bold">
                        {row.formattedPrice}
                      </div>
                    )}
                  </div>
                  <div>
                    <QuantityInputField
                      quantity={row.quantity}
                      onQuantityChange={(q) =>
                        onQuantityInputChange(index, parseInt(q))
                      }
                    />
                  </div>
                  <div>
                    <label className="text-medium lh-1 bold color-grey-900">
                      {translate('quickorder.totalamount')}
                    </label>
                    {row.formattedTotalPrice && (
                      <div className="text-large lh-2 bold">
                        {row.formattedTotalPrice}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {row.articleNumber && row.name && (
                <div className="quick-order-mobile__remove">
                  <i
                    className="[ quick-order-mobile__remove--btn ] [ ph-trash color-error-700 ]"
                    onClick={() => clearRow(index)}
                    title={translate('general.remove')}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default QuickOrderMobileTable;
